module["exports"] = [
  "Böcker",
  "Filmer",
  "Musik",
  "Spel",
  "Elektronik",
  "Datorer",
  "Hem",
  "Trädgård",
  "Verktyg",
  "Livsmedel",
  "Hälsa",
  "Skönhet",
  "Leksaker",
  "Klädsel",
  "Skor",
  "Smycken",
  "Sport"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/commerce/department.js
 ** module id = 1009
 ** module chunks = 0
 **/